import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { UserRole, rolePermissions, defaultPermissions, Actions } from './rolePermissions';
export function defineAbilitiesFor(role) {
    var _a = new AbilityBuilder(createMongoAbility), can = _a.can, cannot = _a.cannot, build = _a.build;
    Object.entries(defaultPermissions).forEach(function (_a) {
        var subject = _a[0], actions = _a[1];
        can(actions, subject);
    });
    if (!role || !Object.values(UserRole).includes(role)) {
        return build();
    }
    var permissions = rolePermissions[role] || {};
    Object.entries(permissions).forEach(function (_a) {
        var subject = _a[0], actions = _a[1];
        if (Array.isArray(actions) && actions.length > 0) {
            can(actions, subject);
        }
        else {
            cannot(Actions.VIEW, subject);
        }
    });
    return build();
}
